import { useContext } from "react";
import styled from "styled-components";
import moment from "moment";
import { FaTrash } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert";
import MenuContext from "../context/menus/MenuContext";
import MensajeNoHayDatos from "./MensajeNoHayDatos";

function ListadoMenus({ menus }) {
  const { estadoPublicado, eliminarMenu } = useContext(MenuContext);

  const handleEliminar = (data) => {
    confirmAlert({
      title: "¿Deséa eliminar?",
      message:
        "Esta apunto de eliminar un menú, precione si para eliminar, no para cancelar",
      buttons: [
        {
          label: "Si",
          onClick: () => {
            eliminarMenu(data);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const handleCambiarPublicado = (id) => {
    confirmAlert({
      title: "¿Cambiar estado?",
      message:
        "Sí está activo al dejar de listar, ni usted ni sus clientes podrán ver este menú",
      buttons: [
        {
          label: "Si",
          onClick: () => {
            estadoPublicado(id);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  return (
    <Container>
      {menus.length === 0 ? (
        <MensajeNoHayDatos mensaje="No se han creado menús para clientes" />
      ) : (
        <Grid>
          {menus.map((menu) => (
            <Card key={menu.id}>
              <CardHeader>
                <p>{moment(menu.fecha).format("dddd, D MMMM YYYY")}</p>
                <button type="button" onClick={() => handleEliminar(menu)}>
                  <FaTrash title="¿Eliminar esté menú?" />
                </button>
              </CardHeader>
              <CardContent>
                <p
                  title="Cambiar el estado"
                  onClick={() => handleCambiarPublicado(menu.id)}
                >
                  {menu.publicado ? (
                    <button type="button" className="ocultar">
                      Quitar para clientes
                    </button>
                  ) : (
                    <span>Oculto para los clientes</span>
                  )}
                </p>
                <img src={menu.plato.imagenUrl} alt={menu.nombre} />
                <h4>{menu.plato.nombre}</h4>
                <p className="precio">LPS {menu.plato.precio}</p>
                <p>Pedidos: {menu.pedidos.length}</p>
                <p className="descripcion">{menu.plato.descripcion}</p>
                <Pedidos>
                  {menu.pedidos.length === 0 ? (
                    <p className="norecords">No se han hecho pedidos aún</p>
                  ) : (
                    menu.pedidos.map((pedido, i) => (
                      <Cliente key={i}>
                        <p>{pedido.cliente.nombre}</p>
                        <p>{pedido.cliente.cell}</p>
                        <p>{pedido.cliente.correo}</p>
                      </Cliente>
                    ))
                  )}
                </Pedidos>
              </CardContent>
            </Card>
          ))}
        </Grid>
      )}
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  margin-bottom: 10px;
  p {
    font-weight: 300;
  }
`;

const Card = styled.div`
  width: 100%;
  padding: 1rem;
  margin-bottom: 30px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #f2f2f2;
  -webkit-box-shadow: 12px 12px 24px #c9cbd0, -12px -12px 24px #ffffff;
  box-shadow: 12px 12px 24px #c9cbd0, -12px -12px 24px #ffffff;
`;

const CardHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  margin-bottom: 10px;

  p {
    text-transform: capitalize;
  }

  button {
    width: 3rem;
    height: 2rem;
    margin-bottom: 5px;
    cursor: pointer;
    border: none;
    border-radius: 5px;
    outline: none;
    transition: all 0.5s ease;
    color: #fff;
    background: #a61f12;
    &:hover {
      background: #d92a1a;
    }
  }
`;

const CardContent = styled.div`
  margin-bottom: 10px;
  img {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .ocultar {
    width: 100%;
    padding: 0.5rem;
    cursor: pointer;
    color: #fff;
    background: #f28705;
    &:hover {
      background: #f2a922;
    }
    border: none;
    outline: 0;
    border-radius: 5px;
  }
  .precio {
    margin-top: 5px;
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 20px;
  }
  .descripcion {
    text-align: justify;
    margin-top: 10px;
    font-size: 12px;
    height: 5rem;
    max-height: 5rem;
    overflow-y: scroll;
  }
`;

const Grid = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  @media (min-width: 500px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }

  @media (min-width: 800px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }

  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
  }
`;

const Pedidos = styled.div`
  margin-top: 10px;
  border-top: 2px solid #262626;
  font-size: 12px;
  height: 5rem;
  max-height: 5rem;
  overflow-y: scroll;
  .norecords {
    color: #d92a1a;
    font-size: 15px;
    text-align: center;
  }
`;

const Cliente = styled.div`
  width: 100%;
  padding: 0.2rem;
  margin-top: 5px;
  margin-bottom: 5px;
  background: #f2f2f2;
  border-bottom: 1px solid #262626;
`;

export default ListadoMenus;
